export default __webpack_public_path__ + "static/media/googlePlay.c0ce6de8.png";